import React from "react";

function Footer({ lightMode }){

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    //const hour = currentDate.getHours() +":"+ currentDate.getMinutes();


    return(
        <>
        <div className={`footer py-8 ${ lightMode ? "text-black font-medium" : "text-white" }`}>
            <div className="flex justify-center items-center">
            <p className="inline">Copyright &copy; {year}</p>
            <p className="ml-2 inline">&#124;</p>
            <p className="ml-2">Niyaz Ahamed. All right reserved.</p>
        </div>
        </div>
        </>
    );
}

export default Footer;